import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { impactLevelInfo } from "../../app/riskLevel";
import React from "react";
import { NONE } from "../UserVisibleStrings";


type ImpactIconProps = {
    level: string,
    width: number,
    blackAndWhite?: boolean,
    includeText?: boolean,
    noPadding?: boolean,
};



export default function ImpactIcon( { level, width, blackAndWhite = false, includeText = false, noPadding = false }: Readonly<ImpactIconProps> )
{
    const myComponentStyle = {
        color: "black",
        "--fa-secondary-color": blackAndWhite ? "white" : level !== NONE ? impactLevelInfo[level].color : "white",
        "--fa-secondary-opacity": 1,
        paddingRight: noPadding ? "0px" : "10px"
    };
    const icon = (
        <FontAwesomeIcon icon = {impactLevelInfo[level].icon} fontSize = {width}
            style = {myComponentStyle}
        />
    );
    if ( includeText )
    {
        const label = level !== NONE ? level + " Impact" : level;
        return (
            <React.Fragment>
                {icon}
                <span>{label}</span>
            </React.Fragment>
        );
    }
    return icon;
}
